import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import extractText from 'flarum/common/utils/extractText';
import PodiumSection from './PodiumSection';
import TopContendersGrid from './TopContendersGrid';
import LeaderboardList from './LeaderboardList';
import LeaderboardState from '../utils/LeaderboardState';
const PERIODS = ['all', 'yearly', 'quarterly', 'monthly', 'weekly', 'daily'];
export default class LeaderboardPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('canViewLeaderboard')) return;
    this.state = new LeaderboardState();
    this.state.load('all');
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    const leaderboardName = app.forum.attribute('huseyinfiliz-leaderboard.leaderboard_name') || extractText(app.translator.trans('huseyinfiliz-leaderboard.forum.nav.leaderboard'));
    app.setTitle(leaderboardName);
  }
  view() {
    return m(PageStructure, {
      className: "IndexPage LeaderboardPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this)
    }, this.contentView());
  }
  hero() {
    const leaderboardName = app.forum.attribute('huseyinfiliz-leaderboard.leaderboard_name') || 'Leaderboard';
    return m("header", {
      className: "Hero LeaderboardHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, m("i", {
      "aria-hidden": "true",
      className: "icon fas fa-trophy"
    }), " ", leaderboardName))));
  }
  sidebar() {
    return m(IndexSidebar, null);
  }
  contentView() {
    if (!app.forum.attribute('canViewLeaderboard')) {
      return m("div", {
        className: "LeaderboardPage-denied"
      }, m("p", null, app.translator.trans('huseyinfiliz-leaderboard.forum.permission_denied')));
    }
    return [m("div", {
      className: "LeaderboardPage-filters"
    }, m("button", {
      className: "Button LeaderboardPage-refreshBtn",
      onclick: () => this.state.load(this.state.period),
      disabled: !this.state.isFullyLoaded
    }, m("i", {
      className: "fas fa-sync-alt"
    })), PERIODS.map(p => m("button", {
      key: p,
      className: 'Button LeaderboardPage-filterBtn' + (this.state.period === p ? ' active' : ''),
      onclick: () => this.state.load(p),
      disabled: !this.state.isFullyLoaded
    }, app.translator.trans(`huseyinfiliz-leaderboard.forum.period.${p}`)))), this.state.isEmpty ? m("div", {
      className: "LeaderboardPage-empty"
    }, m("p", null, app.translator.trans('huseyinfiliz-leaderboard.forum.list.no_results'))) : m("div", {
      className: "LeaderboardPage-content"
    }, this.podiumView(), this.contendersView(), this.honorableView())];
  }
  podiumView() {
    if (this.state.podiumLoading) {
      return m("div", {
        className: "LeaderboardPodium LeaderboardSkeleton-podium"
      }, [1, 2, 3].map(i => m("div", {
        className: `LeaderboardPodium-place LeaderboardPodium-place--${i} LeaderboardSkeleton-card`,
        key: i
      }, m("div", {
        className: "LeaderboardSkeleton-badge LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardSkeleton-avatar LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardSkeleton-text LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardSkeleton-textSm LeaderboardSkeleton-pulse"
      }))));
    }
    if (this.state.podiumEntries.length === 0) return null;
    return m(PodiumSection, {
      entries: this.state.podiumEntries
    });
  }
  contendersView() {
    if (this.state.contendersLoading) {
      return m("div", {
        className: "LeaderboardContenders LeaderboardSkeleton-contenders"
      }, m("div", {
        className: "LeaderboardSkeleton-sectionTitle LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardContenders-grid"
      }, [1, 2, 3, 4, 5, 6, 7].map(i => m("div", {
        className: "LeaderboardContenders-card LeaderboardSkeleton-card",
        key: i
      }, m("div", {
        className: "LeaderboardSkeleton-avatar LeaderboardSkeleton-avatarSm LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardSkeleton-text LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardSkeleton-textSm LeaderboardSkeleton-pulse"
      })))));
    }
    if (this.state.contenderEntries.length === 0) return null;
    return m(TopContendersGrid, {
      entries: this.state.contenderEntries
    });
  }
  honorableView() {
    if (this.state.honorableLoading) {
      return m("div", {
        className: "LeaderboardHonorable LeaderboardSkeleton-honorable"
      }, m("div", {
        className: "LeaderboardSkeleton-sectionTitle LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardHonorable-grid"
      }, [1, 2, 3, 4].map(i => m("div", {
        className: "LeaderboardItem LeaderboardSkeleton-item",
        key: i
      }, m("div", {
        className: "LeaderboardSkeleton-rank LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardSkeleton-avatar LeaderboardSkeleton-avatarXs LeaderboardSkeleton-pulse"
      }), m("div", {
        className: "LeaderboardSkeleton-text LeaderboardSkeleton-pulse",
        style: {
          flex: 1
        }
      }), m("div", {
        className: "LeaderboardSkeleton-textSm LeaderboardSkeleton-pulse"
      })))));
    }
    if (this.state.honorableEntries.length === 0) return null;
    return m(LeaderboardList, {
      entries: this.state.honorableEntries,
      state: this.state
    });
  }
}
flarum.reg.add('huseyinfiliz-leaderboard', 'forum/components/LeaderboardPage', LeaderboardPage);